module.exports = __webpack_public_path__ + "static/media/fms.c1232abc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/journey/fms.png
// module id = 317
// module chunks = 0